// This allows us to load Angular components on legacy server-side pages.
import '../app/rxjs-operators';
import {
  Component,
  OnInit,
  SkipSelf,
  Injector,
  NgModuleFactory,
  NgModuleFactoryLoader,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { components } from './components';

@Component({
  selector: 'webapp-compat',
  template: `
    <ng-container #entryPoint></ng-container>
  `,
})
export class CompatComponent implements OnInit {
  @ViewChild('entryPoint', { read: ViewContainerRef })
  entryPoint: ViewContainerRef;

  constructor(
    @SkipSelf() private injector: Injector,
    private loader: NgModuleFactoryLoader,
  ) {}

  ngOnInit() {
    components.forEach(({ selector, loadChildren, component }) => {
      // Only bootstrap the components on the page
      if (document.getElementsByTagName(selector)[0]) {
        this.loader
          .load(loadChildren)
          .then((ngModuleFactory: NgModuleFactory<any>) => {
            // NgModuleFactory
            const componentFactory = ngModuleFactory
              .create(this.injector) // ngModuleRef
              .componentFactoryResolver.resolveComponentFactory(component);
            this.entryPoint.createComponent(componentFactory);
          });
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/compat/compat.component.ts